import styled from 'styled-components'

export const Title = styled.h2<{
  fontSize?: number | null
  textColor?: string
  noUnderscore?: boolean
  isActive?: boolean
}>`
  color: ${({ isActive, theme }) =>
    isActive
      ? theme.semantics.zap.surface.primary
      : theme.semantics.zap.surface.primary}!important;

  font-style: normal;
  font-weight: normal;
  font-size: ${({ fontSize }) => fontSize ?? 60}px;
  line-height: ${({ fontSize }) => fontSize ?? 68}px;

  margin-bottom: 11px;
  text-transform: uppercase;

  color: #fffcfc;
`
